import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { GridColDefsData } from 'src/app/pages/panelControl/models/grid-col-defs-data';
import { ResumenFirmas } from 'src/app/pages/panelControl/models/resumen-firmas';
import { ResumenEstados } from 'src/app/pages/panelControl/models/resumen-inicial';
import { EstadosFirmaService } from 'src/app/pages/panelControl/services/estados-firma.service';
import { ResumenFirmasSqp } from 'src/app/shared/components/sqp-components/sqpResumenEstados/models/resumen-firmas-sqp';

@Component({
  selector: 'app-boton-resumen-firmas',
  templateUrl: './boton-resumen-firmas.component.html',
  styleUrls: ['./boton-resumen-firmas.component.css']
})
export class BotonResumenFirmasComponent implements OnInit {

  @Input() resumenEstados: ResumenEstados[] = [];

  constructor(private router: Router,
              public estadosFirmaService: EstadosFirmaService) {
  }

  ngOnInit() {
  }

  goToFirmas(){
    this.router.navigate(['panel/envios']);
  }

}
